"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Command as CommandPrimitive } from "cmdk";
// import { Search } from "lucide-react"
import { cn } from "../utils";
import { Dialog, DialogContent } from "./Dialog";
import { SIcon } from "../../components";
const Command = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx(CommandPrimitive, {
        ref: ref,
        className: cn("flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground", className),
        ...props
    }));
Command.displayName = CommandPrimitive.displayName;
const CommandDialog = ({ children, ...props })=>{
    return /*#__PURE__*/ _jsx(Dialog, {
        ...props,
        children: /*#__PURE__*/ _jsx(DialogContent, {
            className: "overflow-hidden p-0 shadow-lg",
            children: /*#__PURE__*/ _jsx(Command, {
                className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5",
                children: children
            })
        })
    });
};
const CommandInput = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsxs("div", {
        className: "flex items-center border-b border-white/10 px-4",
        "cmdk-input-wrapper": "",
        children: [
            /*#__PURE__*/ _jsx(SIcon, {
                type: "search",
                className: "h-3.5 w-3.5 shrink-0 opacity-50"
            }),
            /*#__PURE__*/ _jsx(CommandPrimitive.Input, {
                ref: ref,
                className: cn("flex h-11 w-full focus:!outline-none focus:!border-transparent rounded-md bg-transparent py-3 text-sm outline-none border-none  disabled:cursor-not-allowed disabled:opacity-50", className),
                ...props
            })
        ]
    }));
CommandInput.displayName = CommandPrimitive.Input.displayName;
const CommandList = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx(CommandPrimitive.List, {
        ref: ref,
        className: cn("max-h-[300px] overflow-y-auto overflow-x-hidden", className),
        ...props
    }));
CommandList.displayName = CommandPrimitive.List.displayName;
const CommandEmpty = /*#__PURE__*/ React.forwardRef((props, ref)=>/*#__PURE__*/ _jsx(CommandPrimitive.Empty, {
        ref: ref,
        className: "py-6 text-center text-white/50 text-sm",
        ...props
    }));
CommandEmpty.displayName = CommandPrimitive.Empty.displayName;
const CommandGroup = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx(CommandPrimitive.Group, {
        ref: ref,
        className: cn("overflow-hidden p-1 text-white [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-white/50", className),
        ...props
    }));
CommandGroup.displayName = CommandPrimitive.Group.displayName;
const CommandSeparator = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx(CommandPrimitive.Separator, {
        ref: ref,
        className: cn("-mx-1 h-px bg-white/10", className),
        ...props
    }));
CommandSeparator.displayName = CommandPrimitive.Separator.displayName;
const CommandItem = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx(CommandPrimitive.Item, {
        ref: ref,
        className: cn("relative text-white/[0.80] hover:bg-white/10 hover:text-white flex cursor-pointer gap-2 select-none items-center px-2 py-1.5 text-sm outline-none data-[disabled='true']:pointer-events-none rounded-md data-[selected='true']:bg-white/10 data-[selected='true']:text-white data-[disabled='true']:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-3.5 [&_svg]:shrink-0", className),
        ...props
    }));
CommandItem.displayName = CommandPrimitive.Item.displayName;
const CommandShortcut = ({ className, ...props })=>{
    return /*#__PURE__*/ _jsx("span", {
        className: cn("ml-auto text-xs tracking-widest text-white/50", className),
        ...props
    });
};
CommandShortcut.displayName = "CommandShortcut";
export { Command, CommandDialog, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem, CommandShortcut, CommandSeparator,  };
